import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';

import { AppEndpointConfig } from '~/contexts/app-config';
import { GetAppUpdateStateDocument } from '~/types';

export const createAppUpdateClient = ({ http, host }: AppEndpointConfig) => {
    return new ApolloClient({
        link: new HttpLink({ uri: `${http}://${host}/member-api/graphql/` }),
        cache: new InMemoryCache()
    });
};

export type AppUpdateState = 'OK' | 'APP_STORE_REQUIRED' | 'APP_OTA_REQUIRED';

export async function clientAppUpdateState(client: ApolloClient, version: string): Promise<AppUpdateState> {
    try {
        const { data, error } = await client.query({ query: GetAppUpdateStateDocument, variables: { version } });
        if (data) {
            return data.appUpdateState;
        } else {
            throw new Error(`Client app update state query failed: ${error}`);
        }
    } catch (error: unknown) {
        throw new Error(`Client app update state query failed: ${error}`);
    }
}
